import { DashboardProps } from "./types/dashboardProps.d";
import DashboardWidgetHeaderNotification from "./widgets/header-notification.widget";
import DashboardWidgetTherapistCaseload from "./widgets/therapist/caseload.widget";
import DashboardWidgetTherapistMyTeam from "./widgets/therapist/my-team.widget";
import DashboardWidgetTherapistNotifications from "./widgets/therapist/notifications.widget";
import DashboardWidgetTherapistTimesheets from "./widgets/therapist/timesheets.widget";

const TherapistDashboard = ({ discipline, user }: DashboardProps): JSX.Element => {
  return (
    <div className="dashboard defaultDashboard">
      <div className="w-full">
        <DashboardWidgetHeaderNotification discipline={discipline} user={user} />
      </div>
      <div className="grid grid-cols-3">
        <DashboardWidgetTherapistCaseload discipline={discipline} user={user} />
        <DashboardWidgetTherapistMyTeam discipline={discipline} user={user} />
        <DashboardWidgetTherapistNotifications discipline={discipline} user={user} />
        {/* Hidden as per PTSU-37 ~chriczko */}
        {/*<DashboardWidgetTherapistGeneral user={user} />*/}
        <DashboardWidgetTherapistTimesheets discipline={discipline} user={user} />
        {/* Hidden as per PTSU-37 ~chriczko */}
        {/*<DashboardWidgetTherapistReports user={user} />*/}
      </div>
    </div>
  );
};

export default TherapistDashboard;
